export enum RuleEventType {
  UTWORZENIE_NOWEJ_WERSJI_REGULAMINU = 'Utworzenie nowej wersji regulaminu',
  EDYCJA_REGULAMINU = 'Edycja regulaminu',
  USUNIECIE_PLANOWANEJ_WERSJI_REGULAMINU = 'Usunięcie planowanej wersji regulaminu',
  AUTOMATYCZNE_ZAMKNIECIE_POPRZEDNIEJ_WERSJI_REGULAMINU = 'Automatyczne zamknięcie poprzedniej wersji regulaminu',
  AUTOMATYCZNE_PRZYWROCENIE_BEZTERMINOWOSCI_REGULAMINU = 'Automatyczne przywrócenie bezterminowości regulaminu',
}
